import * as React from 'react';

const SvgWaveTwoDesk = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1512 138"
    fill="none"
    {...props}
  >
    <g clipPath="url(#tools_top_desk_svg__a)">
      <path
        fill="url(#tools_top_desk_svg__b)"
        d="M1523.59 1877.5c-80.06-18.64-223.37-104.2-382.18-102.1-158.814 2.1-220.502 115.03-378.002 119.5-157.5 4.46-222.616-91.22-380.116-85.44-157.5 5.77-266.436 142.85-377.999 105.84C-106.269 1878.29-487.625 231.185-107 106.497c53.087 11.631 193.5 38.5 442.101 28.001 248.601-10.498 270.768-54.121 429-55.5 138.972-1.21 288.399 56.499 439.399 56.499 136 0 241.9-73.499 367.9-36.499"
      />
      <g clipPath="url(#tools_top_desk_svg__c)">
        <path
          fill="url(#tools_top_desk_svg__d)"
          d="M-35 30.065c82.498 4.325 240.356 61.99 404 56.853 163.644-5.136 227.031-56.448 389.323-56.853C920.614 29.66 985.708 75.613 1148 75.478c162.29-.136 273.54-110.851 388.5-62.06 114.96 48.792 555.32 168.752 163.11 294.312C1307.41 433.29 80.755 564.527-345.261 632.105"
          opacity={0.05}
        />
        <path
          fill="url(#tools_top_desk_svg__e)"
          d="M-27.169 81.965c82.498 4.325 232.348 25.896 395.992 20.76 163.644-5.136 227.208-45.007 389.5-45.412 162.291-.406 227.208 43.601 389.497 43.466 162.29-.135 274.55-92.906 389.5-44.115 114.96 48.791 554.5 152.754 162.29 278.314-392.2 125.56-1618.855 256.797-2044.871 324.375"
          opacity={0.53}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="tools_top_desk_svg__b"
        x1={-105140}
        x2={-105140}
        y1={1025.25}
        y2={-59458}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_top_desk_svg__d"
        x1={109881}
        x2={109881}
        y1={15.237}
        y2={61702.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <linearGradient
        id="tools_top_desk_svg__e"
        x1={109881}
        x2={109881}
        y1={42.484}
        y2={61729.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3996B3" />
      </linearGradient>
      <clipPath id="tools_top_desk_svg__a">
        <path fill="#fff" d="M1512 138H0V0h1512z" />
      </clipPath>
      <clipPath id="tools_top_desk_svg__c">
        <path fill="#fff" d="M-22-249h1558v519H-22z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveTwoDesk;
